import React from 'react';
import { Link } from 'react-router-dom';
import WhyChooseVallenAI from './WhyChooseVallenAI';

const ProblemSolution = () => {
  const problems = [
    {
      icon: 'bi-exclamation-triangle',
      title: 'Poor Data Quality',
      description: 'Most companies have scattered, incomplete, or low-quality data that prevents effective AI implementation and accurate insights.',
      impact: 'Failed Analysis',
      color: '#ef4444'
    },
    {
      icon: 'bi-clock-history',
      title: 'Lack of Stakeholder Alignment',
      description: 'Teams work in silos without clear communication, leading to misaligned AI goals and failed project outcomes.',
      impact: 'Project Delays',
      color: '#ef4444'
    },
    {
      icon: 'bi-gear',
      title: 'Generic AI Solutions',
      description: 'Off-the-shelf AI tools don\'t fit specific business needs, resulting in poor performance and wasted investments.',
      impact: 'Low ROI',
      color: '#ef4444'
    }
  ];


  return (
    <section className="problem-solution-section py-5" style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(14, 165, 233, 0.03) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(30, 64, 175, 0.02) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row align-items-stretch">
          {/* Left Side - Problems */}
          <div className="col-12 col-lg-6 mb-5 mb-lg-0">
              <div style={{
              background: '#ffffff',
              border: '1px solid #cbd5e1',
              borderRadius: '20px',
              padding: '2.5rem',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
              minHeight: '600px'
            }}>
              <div className="text-center" style={{ marginBottom: '2rem' }}>
              <h2 style={{
                fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1.5rem',
                lineHeight: '1.2'
              }}>
                  Why Most AI{' '}
                <span style={{
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                  }}>Solutions Fall Flat</span>
              </h2>
            </div>

            <div className="row g-3">
              {problems.map((problem, index) => (
                <div key={index} className="col-12">
                  <div style={{
                      background: '#f8fafc',
                      border: '2px solid #e2e8f0',
                    borderRadius: 'clamp(12px, 2.5vw, 16px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                      minHeight: 'clamp(180px, 35vw, 220px)',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                      flexDirection: 'column',
                      position: 'relative',
                      overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                      e.currentTarget.style.borderColor = problem.color;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
                      e.currentTarget.style.borderColor = '#e2e8f0';
                    }}>
                      {/* Grid Layout for Perfect Horizontal Alignment */}
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'space-between'
                      }}>
                        {/* Row 1: Icon + Title in one horizontal line */}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'clamp(0.75rem, 2vw, 1rem)',
                          marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                          flexShrink: 0
                  }}>
                    <div style={{
                            width: 'clamp(35px, 8vw, 45px)',
                            height: 'clamp(35px, 8vw, 45px)',
                      background: problem.color,
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                            boxShadow: `0 6px 15px ${problem.color}30`,
                      flexShrink: 0
                    }}>
                      <i className={`bi ${problem.icon}`} style={{
                        color: 'white',
                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)'
                      }}></i>
                    </div>
                      <h4 style={{
                        fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                        fontWeight: '700',
                        color: '#1e293b',
                            lineHeight: '1.3',
                            margin: 0
                      }}>
                        {problem.title}
                      </h4>
                        </div>

                        {/* Row 2: Description - Flexible height */}
                        <div style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'flex-start',
                          marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
                        }}>
                      <p style={{
                            fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                        color: '#64748b',
                        lineHeight: '1.5',
                            margin: 0
                      }}>
                        {problem.description}
                      </p>
                        </div>

                        {/* Row 3: Impact Badge - Fixed at bottom */}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexShrink: 0
                        }}>
                      <span style={{
                        fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                          fontWeight: '700',
                        color: problem.color,
                        textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          padding: 'clamp(0.4rem, 1.5vw, 0.5rem) clamp(0.75rem, 2vw, 1rem)',
                          background: problem.color + '20',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          border: `1px solid ${problem.color}40`,
                          boxShadow: `0 2px 8px ${problem.color}20`,
                          whiteSpace: 'nowrap'
                      }}>
                        {problem.impact}
                      </span>
                        </div>
                    </div>
                  </div>
                </div>
              ))}
              </div>
            </div>
          </div>

          {/* Right Side - How Vallen AI Solves These Problems */}
          <div className="col-12 col-lg-6">
            <div style={{
              background: '#ffffff',
              border: '1px solid #cbd5e1',
              borderRadius: '20px',
              padding: '2.5rem',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
              position: 'relative',
              overflow: 'hidden',
              height: '100%',
              minHeight: '600px'
            }}>
              <div className="text-center" style={{ marginBottom: '2rem' }}>
                <h3 style={{
                  fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '1.5rem',
                  lineHeight: '1.2'
                }}>
                  How{' '}
                  <span style={{
                    background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}>Vallen AI</span>
                  {' '}Brings Real Impact
                </h3>
              </div>

              {/* Solutions */}
              <div className="row g-3">
                <div className="col-12">
                  <div style={{
                    background: '#ffffff',
                    border: '2px solid #e2e8f0',
                    borderRadius: 'clamp(12px, 2.5vw, 16px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                    minHeight: 'clamp(180px, 35vw, 220px)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#0ea5e9';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                  }}>
                    {/* Grid Layout for Perfect Horizontal Alignment */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      justifyContent: 'space-between'
                    }}>
                      {/* Row 1: Icon + Title in one horizontal line */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'clamp(0.75rem, 2vw, 1rem)',
                        marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                        flexShrink: 0
                      }}>
                        <div style={{
                          width: 'clamp(35px, 8vw, 45px)',
                          height: 'clamp(35px, 8vw, 45px)',
                      background: '#0ea5e9',
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                          boxShadow: '0 6px 15px rgba(14, 165, 233, 0.3)',
                      flexShrink: 0
                    }}>
                      <i className="bi bi-graph-up" style={{ color: 'white', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}></i>
                    </div>
                        <h4 style={{
                          fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                          fontWeight: '700',
                          color: '#1e293b',
                          lineHeight: '1.3',
                          margin: 0
                        }}>
                          Data Quality Assessment
                      </h4>
                      </div>

                      {/* Row 2: Description - Flexible height */}
                      <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
                      }}>
                        <p style={{
                          fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                          color: '#64748b',
                          lineHeight: '1.5',
                          margin: 0
                        }}>
                          We audit your data sources, clean and standardize your datasets, and ensure data quality before building any AI solution to guarantee accurate results.
                        </p>
                      </div>

                      {/* Row 3: Solution Badge - Fixed at bottom */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0
                      }}>
                        <span style={{
                          fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                          fontWeight: '700',
                          color: '#0ea5e9',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          padding: 'clamp(0.4rem, 1.5vw, 0.5rem) clamp(0.75rem, 2vw, 1rem)',
                          background: '#0ea5e920',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          border: '1px solid #0ea5e940',
                          boxShadow: '0 2px 8px rgba(14, 165, 233, 0.2)',
                          whiteSpace: 'nowrap'
                        }}>
                          DATA CLEANING
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div style={{
                    background: '#ffffff',
                    border: '2px solid #e2e8f0',
                    borderRadius: 'clamp(12px, 2.5vw, 16px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                    minHeight: 'clamp(180px, 35vw, 220px)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#0ea5e9';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                  }}>
                    {/* Grid Layout for Perfect Horizontal Alignment */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      justifyContent: 'space-between'
                    }}>
                      {/* Row 1: Icon + Title in one horizontal line */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'clamp(0.75rem, 2vw, 1rem)',
                        marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                        flexShrink: 0
                      }}>
                        <div style={{
                          width: 'clamp(35px, 8vw, 45px)',
                          height: 'clamp(35px, 8vw, 45px)',
                      background: '#0ea5e9',
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                          boxShadow: '0 6px 15px rgba(14, 165, 233, 0.3)',
                      flexShrink: 0
                    }}>
                      <i className="bi bi-people-fill" style={{ color: 'white', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}></i>
                    </div>
                        <h4 style={{
                          fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                          fontWeight: '700',
                          color: '#1e293b',
                          lineHeight: '1.3',
                          margin: 0
                        }}>
                          Team Alignment Process
                      </h4>
                      </div>

                      {/* Row 2: Description - Flexible height */}
                      <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
                      }}>
                        <p style={{
                          fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                          color: '#64748b',
                          lineHeight: '1.5',
                          margin: 0
                        }}>
                          We facilitate cross-departmental workshops, establish clear communication channels, and create unified AI goals that all teams can work towards together.
                        </p>
                      </div>

                      {/* Row 3: Solution Badge - Fixed at bottom */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0
                      }}>
                        <span style={{
                          fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                          fontWeight: '700',
                          color: '#0ea5e9',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          padding: 'clamp(0.4rem, 1.5vw, 0.5rem) clamp(0.75rem, 2vw, 1rem)',
                          background: '#0ea5e920',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          border: '1px solid #0ea5e940',
                          boxShadow: '0 2px 8px rgba(14, 165, 233, 0.2)',
                          whiteSpace: 'nowrap'
                        }}>
                          UNIFIED GOALS
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div style={{
                    background: '#ffffff',
                    border: '2px solid #e2e8f0',
                    borderRadius: 'clamp(12px, 2.5vw, 16px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                    minHeight: 'clamp(180px, 35vw, 220px)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.borderColor = '#0ea5e9';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.05)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                  }}>
                    {/* Grid Layout for Perfect Horizontal Alignment */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      justifyContent: 'space-between'
                    }}>
                      {/* Row 1: Icon + Title in one horizontal line */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'clamp(0.75rem, 2vw, 1rem)',
                        marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
                        flexShrink: 0
                      }}>
                        <div style={{
                          width: 'clamp(35px, 8vw, 45px)',
                          height: 'clamp(35px, 8vw, 45px)',
                      background: '#0ea5e9',
                      borderRadius: 'clamp(8px, 2vw, 12px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                          boxShadow: '0 6px 15px rgba(14, 165, 233, 0.3)',
                      flexShrink: 0
                    }}>
                      <i className="bi bi-gear-fill" style={{ color: 'white', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}></i>
                    </div>
                        <h4 style={{
                          fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                          fontWeight: '700',
                          color: '#1e293b',
                          lineHeight: '1.3',
                          margin: 0
                        }}>
                          Tailored AI Implementation
                      </h4>
                      </div>

                      {/* Row 2: Description - Flexible height */}
                      <div style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
                      }}>
                        <p style={{
                          fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                          color: '#64748b',
                          lineHeight: '1.5',
                          margin: 0
                        }}>
                          We build custom AI solutions specifically designed for your business processes, ensuring perfect fit and maximum ROI instead of forcing generic tools to work.
                        </p>
                      </div>

                      {/* Row 3: Solution Badge - Fixed at bottom */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0
                      }}>
                        <span style={{
                          fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)',
                          fontWeight: '700',
                          color: '#0ea5e9',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          padding: 'clamp(0.4rem, 1.5vw, 0.5rem) clamp(0.75rem, 2vw, 1rem)',
                          background: '#0ea5e920',
                          borderRadius: 'clamp(8px, 2vw, 12px)',
                          border: '1px solid #0ea5e940',
                          boxShadow: '0 2px 8px rgba(14, 165, 233, 0.2)',
                          whiteSpace: 'nowrap'
                        }}>
                          PERFECT FIT
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* CTA Section - Centered below both cards */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
                <Link
                  to="/contact"
                  style={{
                    background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                    border: 'none',
                    color: '#ffffff',
                padding: '1.25rem 3rem',
                borderRadius: '16px',
                fontWeight: '700',
                fontSize: '1.1rem',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                gap: '0.75rem',
                    transition: 'all 0.3s ease',
                boxShadow: '0 8px 25px rgba(14, 165, 233, 0.3)',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
                  }}
                  onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 12px 35px rgba(14, 165, 233, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 25px rgba(14, 165, 233, 0.3)';
                  }}
                >
                  Get Your AI Solution
              <i className="bi bi-arrow-right" style={{ fontSize: '1.2rem' }}></i>
                </Link>
          </div>
        </div>

        {/* Why Choose Vallen AI */}
        <WhyChooseVallenAI />
      </div>
    </section>
  );
};

export default ProblemSolution;
